import { render, staticRenderFns } from "./TeleMarketThirdTypeRelation.vue?vue&type=template&id=172c9411&scoped=true"
import script from "./TeleMarketThirdTypeRelation.vue?vue&type=script&lang=js"
export * from "./TeleMarketThirdTypeRelation.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketThirdTypeRelation.vue?vue&type=style&index=0&id=172c9411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c9411",
  null
  
)

export default component.exports